export default {
  extrasAndDeductions: {
    extraOrDeduction: "إضافة أو خصم",
    debitOrCredit: "debit or credit",
    create: "صنع {type}",
    edit: "تعديل {type}",
    delete: "مسح",
  },
}
